import React, { useCallback, useState } from 'react';
import { slots } from '../data/slots';
import { homeFaq } from '../data/faq';
import type { Slot } from '../types/slot';
import { useSiteSettings } from '../contexts/SiteSettingsContext';
import { useSeo } from '../hooks/useSeo';
import { YEAR, faqLd, organizationLd, slotItemListLd, websiteLd } from '../utils/seo';
import { HomeHero } from '../components/home/HomeHero';
import { RankingSection } from '../components/ranking/RankingSection';
import { CasinoTable } from '../components/home/CasinoTable';
import { MethodologySection } from '../components/home/MethodologySection';
import { ProviderSection } from '../components/home/ProviderSection';
import { FaqSection } from '../components/FaqSection';
import { DemoModal } from '../components/DemoModal';
export function Home() {
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  const [demoSlot, setDemoSlot] = useState<Slot | null>(null);
  const close = useCallback(() => setDemoSlot(null), []);
  useSeo({
    title: `Top 30 Beste Online Slots & Pokies in Nieuw-Zeeland (${YEAR}) | SlotGids`,
    description: 'De 30 beste online slots en pokies in Nieuw-Zeeland, onafhankelijk beoordeeld voor Nederlandstalige spelers. Vergelijk RTP, volatiliteit en max. winst en speel elke slot gratis in de demo.',
    path: '/',
    jsonLd: [organizationLd(), websiteLd(), slotItemListLd(slots, `Top 30 beste online slots in Nieuw-Zeeland ${YEAR}`), faqLd(homeFaq)]
  });
  return <main data-id="element-396" data-mp="2d6xdg27naewv">
      <HomeHero onDemo={setDemoSlot} data-id="element-397" data-mp="2d65srmfl61ld" />
      <div className="space-y-20" data-id="element-398" data-mp="2d547kp4uvypx">
        <RankingSection onDemo={setDemoSlot} data-id="element-399" data-mp="287krrksifdvv" />
        {showRealMoneyCtas && <CasinoTable data-id="element-400" data-mp="285rj5zyc6jl8" />}
        <MethodologySection data-id="element-401" data-mp="239awzbap6fas" />
        <ProviderSection data-id="element-402" data-mp="23a2jzxq8b4pg" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-403" data-mp="23aucv0sfyoc1">
          <div className="border-t border-line pt-16" data-id="element-404" data-mp="1z7pdv87kl4s5">
            <FaqSection id="faq" title="Veelgestelde vragen over online slots in Nieuw-Zeeland" items={homeFaq} size="lg" data-id="element-405" data-mp="1z98tqxpbddte" />
          </div>
        </div>
      </div>
      <DemoModal slot={demoSlot} onClose={close} data-id="element-406" data-mp="1kjxqz8f7f7al" />
    </main>;
}